import type { AutoRenewPeriod } from "./generated";

/**
 * Normalizes auto-renewal period to string enum value
 * @param value - AutoRenewPeriod string value, null, or undefined
 * @returns AutoRenewPeriod string value ("Monthly" or "Annually"), or null if disabled
 */
export function normalizeAutoRenewPeriod(value: AutoRenewPeriod | null | undefined): AutoRenewPeriod | null {
  if (value === null || value === undefined) {
    return null;
  }
  return value;
}

/**
 * Gets human-readable label for auto-renewal period
 * @param value - AutoRenewPeriod string value, null, or undefined
 * @returns Human-readable label ("Monthly", "Annually", or "Disabled")
 */
export function getAutoRenewPeriodLabel(value: AutoRenewPeriod | null | undefined): string {
  const normalized = normalizeAutoRenewPeriod(value);
  if (normalized === null) {
    return "Disabled";
  }
  return normalized;
}
